// src/DashboardPage.js
import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
Chart.register(ArcElement, Tooltip, Legend);

const DashboardPage = ({ leads, statuses }) => {
  const totalLeads = leads.length;
  const scaduti = leads.filter(lead => {
    if (!lead.data_scadenza) return false;
    const today = new Date();
    const scadenza = new Date(lead.data_scadenza);
    return scadenza < today;
  }).length;
  const registrati = leads.filter(lead => lead.stato === "Registrati").length;
  const conversionRate = totalLeads > 0 ? ((registrati / totalLeads) * 100).toFixed(1) : 0;

  const leadPerStato = {};
  statuses.forEach(status => {
    leadPerStato[status.name] = leads.filter(lead => lead.stato === status.name).length;
  });

  const chartData = {
    labels: Object.keys(leadPerStato),
    datasets: [
      {
        label: "Lead per Stato",
        data: Object.values(leadPerStato),
        backgroundColor: [
          "#3B82F6", "#F59E0B", "#10B981", "#EF4444", "#8B5CF6", "#F87171"
        ],
      },
    ],
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-6 text-center md:text-left">📊 Dashboard Analytics</h1>

      <div className="mb-6 flex justify-center md:justify-start">
        <a 
          href="/calendar" 
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition text-center"
        >
          📅 Vai al Calendario
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white p-4 sm:p-6 rounded shadow text-center">
          <div className="text-2xl sm:text-3xl font-bold">{totalLeads}</div>
          <div className="text-gray-500">Totale Lead</div>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded shadow text-center">
          <div className="text-2xl sm:text-3xl font-bold">{scaduti}</div>
          <div className="text-gray-500">Lead Scaduti</div>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded shadow text-center">
          <div className="text-2xl sm:text-3xl font-bold">{registrati}</div>
          <div className="text-gray-500">Lead Registrati</div>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded shadow text-center">
          <div className="text-2xl sm:text-3xl font-bold">{conversionRate}%</div>
          <div className="text-gray-500">Tasso Conversione</div>
        </div>
      </div>

      <div className="bg-white p-4 sm:p-6 rounded shadow flex flex-col items-center">
        <h2 className="text-lg sm:text-xl font-semibold mb-4 text-center">Lead per Stato</h2>
        <div className="relative w-full max-w-xs sm:max-w-sm h-[300px]">
          <Pie 
            data={chartData}
            options={{
              maintainAspectRatio: false,
              responsive: true
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
